export const WarningIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='25'
    viewBox='0 0 24 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M11.9902 15.5098C11.3922 15.5098 11 15.0686 11 14.5392C11 14.0196 11.3922 13.5882 11.9902 13.5882C12.5784 13.5882 13 14.0196 13 14.5392C13 15.0686 12.5784 15.5098 11.9902 15.5098ZM11.3431 8.5H12.6471L12.4216 12.8627H11.5686L11.3431 8.5Z'
      fill='currentColor'
    />
    <path
      d='M11.5654 5.26758C11.7574 4.93167 12.2426 4.93167 12.4346 5.26758L18.7109 16.252C18.9014 16.5853 18.6603 17 18.2764 17H5.72363C5.33973 17 5.0986 16.5853 5.28906 16.252L11.5654 5.26758Z'
      stroke='currentColor'
    />
  </svg>
)
